module.exports = __webpack_public_path__ + "static/media/cert_146.abab0f10.jpg";